export type IdpWebKey = 'FG' | 'ST' | 'BF'
export type IdpSiteId = 0 | 1 | 2
export type IdpSiteFilter = '0' | '1' | '2'

export const SITE_TO_WEB_KEY: Record<string, IdpWebKey> = { '0': 'FG', '1': 'ST', '2': 'BF' }
export const WEB_KEY_TO_SITE: Record<IdpWebKey, IdpSiteId> = { FG: 0, ST: 1, BF: 2 }
export const ALL_IDP_WEB_KEYS: IdpWebKey[] = ['FG', 'ST', 'BF']
export const ALL_IDP_SITE_FILTERS: IdpSiteFilter[] = ['0', '1', '2']

export type IdpSiteOption = {
  siteId: IdpSiteFilter;
  webKey: IdpWebKey;
  label: string;
  saleChannelIds: number[];
  channelKeywords: string[];
}

export const IDP_SITE_OPTIONS: IdpSiteOption[] = [{
  siteId: '0',
  webKey: 'FG',
  label: 'FG',
  saleChannelIds: [70],
  channelKeywords: ['fg独立站', 'felicegals', 'felice gals', 'felice-gals'],
}, {
  siteId: '1',
  webKey: 'ST',
  label: 'ST',
  saleChannelIds: [132],
  channelKeywords: ['st独立站', 'starlandus', 'starland us', 'starland-us', 'starland'],
}, {
  siteId: '2',
  webKey: 'BF',
  label: 'BF',
  saleChannelIds: [142],
  channelKeywords: ['bf独立站', 'blingflare', 'bling flare', 'bling-flare'],
}]

function normalizeText(value: any): string {
  return String(value || '').toLowerCase().replace(/[\s_-]+/g, '')
}

function normalizeChannels(payload: any): any[] {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.list)) return payload.list
  if (Array.isArray(payload?.data)) return payload.data
  if (Array.isArray(payload?.records)) return payload.records
  if (payload?.data && typeof payload.data === 'object') return normalizeChannels(payload.data)
  return []
}

function channelMatchesSite(channel: any, site: IdpSiteOption): boolean {
  const id = Number(channel?.id ?? channel?.channelId ?? channel?.saleChannelId)
  const idMatchedSite = IDP_SITE_OPTIONS.find(candidate => candidate.saleChannelIds.includes(id))
  if (idMatchedSite) {
    return idMatchedSite.siteId === site.siteId
  }

  const name = normalizeText(channel?.name || channel?.channelName || channel?.saleChannelName || channel?.label)
  const namedSites = name
    ? IDP_SITE_OPTIONS.filter(candidate => (
      candidate.channelKeywords.some(keyword => name === normalizeText(keyword))
    ))
    : []
  return namedSites.some(candidate => candidate.siteId === site.siteId)
}

export function siteFiltersForSaleChannels(payload: any): IdpSiteFilter[] {
  const channels = normalizeChannels(payload)
  return IDP_SITE_OPTIONS
    .filter(site => channels.some(channel => channelMatchesSite(channel, site)))
    .map(site => site.siteId)
}

export function siteOptionsForFilters(siteFilters: string[] = ALL_IDP_SITE_FILTERS): IdpSiteOption[] {
  const allowed = new Set(siteFilters)
  return IDP_SITE_OPTIONS.filter(site => allowed.has(site.siteId))
}

export function normalizeFilterSite(filterSite: string, siteFilters: string[] = ALL_IDP_SITE_FILTERS): string {
  if (!siteFilters.length) return ''
  if (siteFilters.includes(filterSite)) return filterSite
  // '全部'已下线(2026-07-04 柴进拍板):站点流量分开看,多站合并无业务意义且请求量×3;
  // 'all'/历史 URL/非法值一律落到第一个有权限的站
  return siteFilters[0]
}

export function webKeysForFilter(filterSite: string, siteFilters?: string[]): IdpWebKey[] {
  if (siteFilters && !siteFilters.length) return []
  const allowedFilters = siteFilters && siteFilters.length ? siteFilters : ALL_IDP_SITE_FILTERS
  const nextSite = normalizeFilterSite(filterSite, allowedFilters)
  const webKey = SITE_TO_WEB_KEY[nextSite]
  return webKey ? [webKey] : []
}

export function initialFilterSiteFromSearch(search: string, defaultSite: string, siteFilters?: string[]): string {
  const queryWebKey = new URLSearchParams(search || '').get('webKey') as IdpWebKey | null
  if (queryWebKey && WEB_KEY_TO_SITE[queryWebKey] !== undefined) {
    return normalizeFilterSite(String(WEB_KEY_TO_SITE[queryWebKey]), siteFilters)
  }
  return normalizeFilterSite(defaultSite, siteFilters)
}
